import { Edit, SimpleForm } from 'react-admin';
import { MyFormContainer, MyToolbar } from '@/components/forms';
import { OrganizationFormFields } from './OrganizationForm';

export const OrganizationEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm toolbar={<MyToolbar resource="organizations" />}>
      <MyFormContainer>
        <OrganizationFormFields isCreate={false} />
      </MyFormContainer>
    </SimpleForm>
  </Edit>
);

export default OrganizationEdit;
